import React from 'react';
import Img, { ImgProps } from 'react-cool-img';
import styled from 'styled-components';
import { colors } from 'spw-theme';
import { DEFAULT_AVATAR_IMG } from 'spw-constants';

const AvatarImage = styled(({ className, src, ...props }: ImgProps) => {
  const isDefault = src === DEFAULT_AVATAR_IMG;

  return (
    <Img
      {...props}
      src={src}
      className={`${className} ${isDefault ? 'default-avatar' : ''}`}
    />
  );
})`
  && {
    border-radius: 4px;
    height: 40px;
    width: 40px;
    box-sizing: border-box;
  }

  &.default-avatar {
    border: 1px solid ${colors.veryLightGray};
    padding: 9px;
  }

  &:not(.default-avatar) {
    object-fit: cover;
  }
`;

export default AvatarImage;
